$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  if (p == "login" || p == "adminlogin") {
    if (window.innerWidth <= 768) {
      $("header").hide();
    }
    $(window).on("resize", function () {
      if (window.innerWidth <= 768) {
        $("header").hide();
      } else {
        $("header").show();
      }
    });

    $(document).on("click", ".close-alert", function () {
      $(".incorrect-login-alert").removeClass("show").addClass("d-none");
    });

    $(document).on("click", ".show-password, .hide-password", function () {
      let input = $("#login-password-input");

      if (input.attr("type") === "password") {
        input.attr("type", "text");
        $(".show-password").addClass("d-none");
        $(".hide-password").removeClass("d-none");
      } else {
        input.attr("type", "password");
        $(".hide-password").addClass("d-none");
        $(".show-password").removeClass("d-none");
      }
    });

    function saveCredentialsToMobile(email, password) {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            action: "save_credentials",
            email: email,
            password: password,
          }),
        );
      }
    }

    function clearCredentialsFromMobile() {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            action: "clear_credentials",
          }),
        );
      }
    }

    $(document).on(
      "submit",
      "#user_login_form, #user_login_form_mobile",
      function (e) {
        e.preventDefault();
        let email = $(this).find('input[name="email"]').val();
        let password = $(this).find('input[name="password"]').val();
        let deviceId = localStorage.getItem("deviceID");

        const loginButtonToDisable = $("#user-login-button");
        const btnWidth = loginButtonToDisable.outerWidth();
        loginButtonToDisable.css("width", btnWidth + "px");
        loginButtonToDisable.prop("disabled", true);
        loginButtonToDisable.html(
          '<i class="spinner-border spinner-border-sm"></i>',
        );

        const locations = Object.fromEntries(
          Object.entries(localStorage).filter(([key]) =>
            key.endsWith("_mainLocationId"),
          ),
        );

        const formData = $(this).serializeArray();
        formData.push({
          name: "is_android",
          value: !!window.ReactNativeWebView,
        });
        if (deviceId) formData.push({ name: "device_id", value: deviceId });

        formData.push({ name: "locations", value: JSON.stringify(locations) });

        $.ajax({
          type: "POST",
          url: "/ajax/user/login",
          data: $.param(formData),
        })
          .done(function (data) {
            loginButtonToDisable.prop("disabled", false);
            loginButtonToDisable.html("Logg inn");
            saveCredentialsToMobile(email, password);
            if (data.isAdmin === true) {
              document.location.href = "/admin/dashboard";
            } else if (data.isOrganizer === true) {
              document.location.href = data.redirect_url;
            } else if (data.isSeller === true) {
              document.location.href = "/seller/organizers";
            } else if (data.isDealer === true) {
              document.location.href = "/dealer/organizers";
            } else if (data.isEmployer === true) {
              document.location.href = data.employer_redirect_url;
            }
          })
          .fail(function (data) {
            loginButtonToDisable.prop("disabled", false);
            loginButtonToDisable.html("Logg inn");
            if (
              data.responseJSON.error_message !== undefined &&
              data.responseJSON.error_message !== null
            ) {
              setTimeout(() => {
                $(".incorrect-login-alert")
                  .removeClass("d-none")
                  .addClass("show");
              }, 10);
            }
          });

        return false;
      },
    );
  }
});
